import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

type NavConstructor = {
	header: HTMLElement;
	button: HTMLElement;
	nav: HTMLElement;

	headerExpandedClassName?: string;
	buttonExpandedClassName?: string;
};

export default class Nav {
	header: HTMLElement;
	button: HTMLElement;
	nav: HTMLElement;

	isExpanded = false;
	headerExpandedClassName: string;
	buttonExpandedClassName: string;
	cachedNavDisplay: CSSStyleDeclaration['display'];

	constructor({
		header,
		button,
		nav,
		headerExpandedClassName = 'page-header--expanded',
		buttonExpandedClassName = 'nav-toggle--expanded',
	}: NavConstructor) {
		this.header = header;
		this.button = button;
		this.nav = nav;

		this.headerExpandedClassName = headerExpandedClassName;
		this.buttonExpandedClassName = buttonExpandedClassName;

		this.cachedNavDisplay = getDisplayMode(this.nav) ?? 'block';

		this.header.addEventListener('transitionend', this.handleTransitionEnd);
		this.button.addEventListener('click', this.handleButtonClick);
		window.addEventListener('resize', this.handleWindowResize);
	}

	handleButtonClick = () => {
		if (this.isExpanded) {
			this.header.classList.remove(this.headerExpandedClassName);
			this.button.classList.remove(this.buttonExpandedClassName);
			enableBodyScroll(this.nav);
			this.isExpanded = false;
		} else {
			this.nav.style.display = this.cachedNavDisplay;
			window.setTimeout(() => {
				this.header.classList.add(this.headerExpandedClassName);
				this.button.classList.add(this.buttonExpandedClassName);
				disableBodyScroll(this.nav);
				this.isExpanded = true;
			}, 1);
		}
	};

	handleTransitionEnd = (ev: TransitionEvent) => {
		if (ev.target !== this.nav) {
			return;
		}

		if (!this.isExpanded) {
			this.nav.style.display = 'none';
		}
	};

	handleWindowResize = () => {
		this.nav.setAttribute('style', '');
		this.cachedNavDisplay = getDisplayMode(this.nav) ?? 'block';
	};
}

/**
 * Utilities
 */

const getDisplayMode = (el: HTMLElement) => {
	let directDisplayStyle = el.style.display;
	if (visibleDisplayMode(directDisplayStyle)) {
		return directDisplayStyle;
	}

	el.style.display = '';
	const { display: computedDisplayStyle } = window.getComputedStyle(el);
	el.style.display = directDisplayStyle;

	return visibleDisplayMode(computedDisplayStyle)
		? computedDisplayStyle
		: 'block';
};

const visibleDisplayMode = (mode: string | null) => {
	return mode && mode !== 'none';
};
